/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// third party
import '@hotwired/turbo-rails';
import '@fortawesome/fontawesome-free/css/all.min.css';

// internal
function importAll(r) {
  r.keys().forEach(r);
}
importAll(require.context('./shared/', true, /.(js|scss)$/));
importAll(require.context('./styles/', true, /.(js|scss)$/));

require.context('../images', true);

require('trix');
require('@rails/actiontext');

import { Application } from '@hotwired/stimulus';
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers';

window.Stimulus = Application.start();

import {
  RaincoatGeneralDataTableController,
  RaincoatMDCBannerController,
  RaincoatMDCButtonController,
  RaincoatMDCCardController,
  RaincoatMDCDialogController,
  RaincoatMDCDrawerController,
  RaincoatMDCSelectController,
  RaincoatMDCSwitchController,
  RaincoatMDCTabBarController,
  RaincoatMDCTextFieldController,
  RaincoatMDCTopAppBarController
} from 'raincoat';

Stimulus.register('mdc--banner', RaincoatMDCBannerController);
Stimulus.register('mdc--button', RaincoatMDCButtonController);
Stimulus.register('mdc--card', RaincoatMDCCardController);
Stimulus.register('mdc--dialog', RaincoatMDCDialogController);
Stimulus.register('mdc--drawer', RaincoatMDCDrawerController);
Stimulus.register('mdc--select', RaincoatMDCSelectController);
Stimulus.register('mdc--switch', RaincoatMDCSwitchController);
Stimulus.register('mdc--tab-bar', RaincoatMDCTabBarController);
Stimulus.register('mdc--text-field', RaincoatMDCTextFieldController);
Stimulus.register('mdc--top-app-bar', RaincoatMDCTopAppBarController);
Stimulus.register(
  'raincoat--general-data-table',
  RaincoatGeneralDataTableController
);

const context = require.context('./controllers', true, /\.js$/);
Stimulus.load(definitionsFromContext(context));

require("trix")
require("@rails/actiontext")
import "trix/dist/trix.css";
